import React from 'react';
import Chip from '@mui/material/Chip';
import { OFFERING_STATUS_LABELS, OFFERING_STATUS_COLORS } from '../labels';

interface OfferingStatusChipProps {
  status: string;
  size?: 'small' | 'medium';
}

const OfferingStatusChip: React.FC<OfferingStatusChipProps> = ({ status, size = 'small' }) => {
  const label = OFFERING_STATUS_LABELS[status] ?? status;
  const color = OFFERING_STATUS_COLORS[status] ?? 'default';
  return <Chip label={label} color={color} size={size} />;
};

export default OfferingStatusChip;
